// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellCard-cls1_fGB","cls2":"TasteOfMentionsUpsellCard-cls2_Pz1 TasteOfMentionsUpsellCard-cls1_fGB"};